module.exports = __webpack_public_path__ + "img/resetPassword.9cac2d75.png";